// Smooth scroll on anchor click
const initialHash = window.location.hash;

if (initialHash) {
  // Step 2: Scroll to top instantly to prevent jump
  window.scrollTo(0, 0);
}

document.addEventListener("DOMContentLoaded", function () {


  // 1) Point the worker to the matching version
  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.js';

  // Check if timeout is disabled via membership section settings
  const membershipSection = document.querySelector('[data-disable-popup-timeout]');
  const isTimeoutDisabled = membershipSection && membershipSection.getAttribute('data-disable-popup-timeout') === 'true';
  
  console.log('Timeout disabled:', isTimeoutDisabled);

  // 2) UI elements
  const openButtons = document.querySelectorAll('[data-action="open-popup"]');
  const closeButton = document.querySelector('.custom-modal-main .close-btn');
  const popup  = document.querySelector('.custom-modal-main');
  const popupBody  = document.querySelector('.custom-modal-main .custom-para');
  const progressContainer = document.getElementById('progress-container');
  const progressBar = document.getElementById('progress-bar');
  const progressText = document.getElementById('progress-text');
  const zoomControls = popup.querySelector('.zoom-controls');
  const zoomInBtn  = zoomControls.querySelector('.zoomIn');
  const zoomOutBtn = zoomControls.querySelector('.zoomOut');
  const zoomLevel  = zoomControls.querySelector('.zoomLevel');
  const timeoutMessage = document.querySelector(".timeout-message");


  /*document.querySelectorAll('.non-members [data-action="open-popup"]').forEach(el => {
	el.addEventListener("click", function(event) {
	  event.stopPropagation();
	  event.preventDefault();
	  popup?.classList.add("modal-open");
	});
  });*/

  // Step 3: Smooth scroll to hash target after layout
  if (initialHash) {
	const target = document.getElementById(initialHash.slice(1));
	if (target) {
	  setTimeout(() => {
		const offset = 80; // adjust for sticky headers
		const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
		window.scrollTo({ top, behavior: 'smooth' });
	  }, 100); // delay allows layout to settle
	}
  }

  // Step 4: Handle anchor clicks
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function (e) {
	  const targetId = this.getAttribute('href').slice(1);
	  const target = document.getElementById(targetId);
	  if (target) {
		e.preventDefault();
		const offset = 80;
		const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
		window.scrollTo({ top, behavior: 'smooth' });
		history.pushState(null, null, '#' + targetId);
	  }
	});
  });

  let spinnerTimeout = null;

  function startLoadingSpinner(container = null, delay = 1000) {
	// Schedule spinner to appear only after X ms
	spinnerTimeout = setTimeout(() => {
	  const spinner = document.createElement('div');
	  spinner.className = 'spinner';

	  container.appendChild(spinner);
	}, delay);
  }

  function stopLoadingSpinner(container = null) {
	// Cancel spinner if it hasn't appeared yet
	clearTimeout(spinnerTimeout);
	spinnerTimeout = null;

	// Hide spinner if it’s already showing
	container.querySelector(".spinner")?.remove();
  }

  // Start spinner at the top of the file, so it gets displayed before loading everything else

  document.querySelectorAll('.button[data-action="open-popup"]').forEach(el => {
	if(!el.hasAttribute("data-pdf")) return;
	el.addEventListener("click", function(event) {
	  startLoadingSpinner(popupBody); // Only show spinner if load takes longer than 300ms
	});
  });

  popup?.querySelectorAll(".custom-modal-inner")?.forEach(el => {
	el.addEventListener("click", function(event) {
	  event.stopPropagation();
	});
  });

  var closePopup = function() {
	popup?.classList.remove("modal-open");
	document.body.classList.remove('no-pinch');
	// Clean up overlays and any pending timers
	overlayTimeoutIds.forEach(id => clearTimeout(id));
	overlayTimeoutIds.length = 0;
	popup?.querySelectorAll('.newsletter-overlay')?.forEach(el => el.remove());
  }

  document.addEventListener("click", function(event) {
	if (event.target.closest('#shopify-pc__banner')) return;
	if (event.target.closest('#nutriplus-popup')) return;
	closePopup();
  });

  popup?.querySelectorAll(".close-btn")?.forEach(el => {
	el.addEventListener("click", closePopup);
  });

  function xorEncrypt(text, key) {
	return text.split('').map((char, i) =>
		String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(i % key.length))
	).join('');
  }

  function xorDecrypt(text, key) {
	return text.split('').map((char, i) =>
		String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(i % key.length))
	).join('');
  }

  // Alter links - support both image-with-text and multicolumn sections
  document.querySelectorAll('.custom-image-with-text a[data-action="open-popup"], .multicolumn a[data-action="open-popup"]').forEach(function(link) {
	const originalHref = link.getAttribute('href');
	const title = link.getAttribute('title');

	if (originalHref && title) {
	  // Set data-pdf to original href
	  link.setAttribute('data-pdf', xorEncrypt(originalHref, "🌱"));

	  // Encode the title and create the new href
	  const encodedTitle = encodeURIComponent(title);
	  const newHref = `/pages/wie-vegan?open-modal=true#${encodedTitle}`;
	  link.setAttribute('href', newHref);
	  link.setAttribute('data-anchor', encodedTitle);
	  localizeLink(link);
	}
  });

  const checkbox = document.querySelector('#newsletter-checkbox');
  if (checkbox) {
	checkbox.addEventListener("change", function () {
	  const newValue = checkbox.checked
		  ? "/pages/wie-vegan?guide-highlight=signup-success&open-modal=true"
		  : "/";
	  const returnInput = document.querySelector("input[name='return_to']");
	  if (returnInput) returnInput.value = newValue;
	});
  }

  function localizeLink(link) {
	const url = new URL(window.location.href);

	if(url.pathname.includes("/en")) {
	  let linkURL = link.getAttribute("href");
	  if(!linkURL.includes("/en")) {
		linkURL = linkURL.replace("/pages", "/en/pages");
		link.setAttribute("href", linkURL);
	  }

	  function isAbsoluteURL(str) {
		return /^https?:\/\//i.test(str);
	  }

	  const href = link.getAttribute("href");
	  const foreignURL = isAbsoluteURL(href) ? new URL(href) : new URL(href, window.location.origin);
	  if(window.location.hostname != foreignURL.hostname) {
		link.setAttribute("target", "_blank");
	  }
	}
  }

  let timerStarted = false;
  let startTime = null;
  let countdownInterval = null;

  function IntervalTimer(callback, interval) {
	let intervalId = null;
	let timeoutId = null;
	let remaining = interval;
	let startTime = null;
	let pauseStartTime = null;
	let paused = false;
	let hasStarted = false;

	this.pause = function () {
	  if (paused || (!intervalId && !timeoutId)) return;

	  const now = Date.now();

	  if (intervalId !== null) {
		clearInterval(intervalId);
		intervalId = null;
		remaining = interval - (now - startTime);
	  } else if (timeoutId !== null) {
		clearTimeout(timeoutId);
		timeoutId = null;
		remaining = remaining - (now - startTime);
	  }

	  pauseStartTime = now;
	  paused = true;
	};

	this.resume = function () {
	  if (!paused) return;

	  const now = Date.now();
	  const pauseDuration = now - pauseStartTime;
	  remaining = Math.max(0, remaining); // ensure non-negative
	  pauseStartTime = null;
	  paused = false;

	  startTime = Date.now();
	  callback();
	  intervalId = setInterval(() => {
		callback();
	  }, interval);
	};

	// Start the interval initially
	startTime = Date.now();
	intervalId = setInterval(callback, interval);
	window.intervalId = intervalId;
	hasStarted = true;
  }

  // Adjust UI to feel native to the platform
  if (/Mac|Macintosh|MacIntel|MacPPC|iPod|iPhone|iPad/.test(navigator.platform)) {
	popup.classList.add("macOS");
  }

  const CACHE_KEY = 'ctoken_7f4b';
  const ACCESS_KEY = 'ctoken_30b9';
  const TIME_LIMIT_SECONDS = 30;
  const DELAY_BEFORE_START_MS = 60 * 1000;
  const TIME_LIMIT_MS = TIME_LIMIT_SECONDS * 1000;

  let originalPopupBodyHTML = popupBody.innerHTML;

  function setCookie(name, value, days) {
	const expires = new Date(Date.now() + days * 864e5).toUTCString();
	// Set cookie
	document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
	// Set LocalStorage
	localStorage.setItem(name, value);
  }

  function getCookie(name) {
	// Try to get from cookie
	const cookieValue = document.cookie.split('; ').reduce((r, v) => {
	  const parts = v.split('=');
	  return parts[0] === name ? decodeURIComponent(parts[1]) : r;
	}, '');

	if (cookieValue) return cookieValue;

	// Fallback to LocalStorage
	return localStorage.getItem(name) || '';
  }

  function showMessage() {
	clearPdfContent();
	popupBody.innerHTML = originalPopupBodyHTML;
	progressContainer.style.display = 'none';
	zoomControls.style.display = 'none';
	popup.classList.remove("document");
  }

  function clearPdfContent() {
	Array.from(popupBody.querySelectorAll('.pdf-viewer-container')).forEach(div => div.remove());
  }

  let pdfViewer;
  let eventBus;
  let container;

  async function renderAllPages(pdf) {
	// 4) Load your PDF
	popupBody.innerHTML = '';

	container = document.createElement('div');
	container.className = 'pdf-viewer-container pdfViewer';

	popupBody.appendChild(container);
	container.append(document.createElement('div'));

	// 3) PDF.js viewer setup
	eventBus = new pdfjsViewer.EventBus();
	const linkService = new pdfjsViewer.PDFLinkService({ eventBus });
	pdfViewer = new pdfjsViewer.PDFViewer({
	  container,
	  eventBus,
	  linkService,
	  textLayerMode: 2,
	  useOnlyCssZoom: false
	});

	linkService.setViewer(pdfViewer);
	container.appendChild(pdfViewer.viewer);

	const loadingTask  = pdfjsLib.getDocument(pdf);
	const pdfDocument  = await loadingTask.promise;
	pdfViewer.setDocument(pdfDocument);
	linkService.setDocument(pdfDocument, null);

	eventBus.on('scalechanging', updateZoom);
	updateZoom();

	// 1) Prepare shared state
	let lastScale        = 1;
	let lastContainerW   = null;
	let pageViewportW    = null;
	let resizeTimeout    = null;

	// 2) Once pages are ready, capture the "native" page width
	eventBus.on('pagesinit', () => {
	  const firstPage = pdfViewer._pages[0];
	  if (!firstPage) return;
	  // viewport at scale=1
	  pageViewportW = firstPage.viewport.width;

	  // initial fit
	  fitWidth(pageViewportW, container.clientWidth);

	  // fix missing locales in links
	  const observer = new MutationObserver(() => {
		container.querySelectorAll("a").forEach(function(link) {
		  localizeLink(link);
		});
	  });

	  observer.observe(document.body, { childList: true, subtree: true });

	});

	// 3) Our fit function: width-only, ≤100%, monotonic
	function fitWidth(pageW, containerW) {
	  if (!pageW || !containerW) return;

	  // desired scale
	  const target = Math.min(containerW / pageW, 1.5);
	  // only apply if truly changed
	  if (Math.abs(target - lastScale) < 0.001) return;

	  pdfViewer._setScale(target, false);
	  lastScale = target;
	  lastContainerW = containerW;
	}

	// 4) Hook up ResizeObserver + debounce + RAF
	const ro = new ResizeObserver(entries => {
	  const cw = entries[0].contentRect.width;

	  clearTimeout(resizeTimeout);
	  resizeTimeout = setTimeout(() => {
		// wait for next paint to get final dimensions
		requestAnimationFrame(() => {
		  // if container grew, we allow scale ↑ up to 1
		  // if container shrank, we allow scale ↓ to target
		  fitWidth(pageViewportW, cw);
		});
	  }, 100);
	});
	ro.observe(container);
  }

  // 5) Zoom display updater
  function updateZoom() {
	zoomLevel.textContent = Math.round(pdfViewer.currentScale * 100) + '%';
  }

  function startTimer() {
	if (timerStarted) return;
	timerStarted = true;
	startTime = Date.now();
	progressContainer.style.display = 'flex';
	updateProgress();
	countdownInterval = new IntervalTimer(updateProgress, 250);
  }

  function updateProgress() {
	const elapsed = Date.now() - startTime;
	const fraction = Math.min(elapsed / TIME_LIMIT_MS, 1);
	const dashArray = 2 * Math.PI * 45;
	progressBar.style.strokeDashoffset = dashArray * fraction;
	const remainingSeconds = Math.ceil(Math.max(TIME_LIMIT_MS - elapsed, 0) / 1000);
	progressText.textContent = remainingSeconds;

	if (fraction >= 1) {
	  countdownInterval.pause();
	  clearInterval(countdownInterval.intervalId);
	  clearTimeout(countdownInterval.timeoutId);
	  timerStarted = false;
	  progressContainer.style.display = 'none';
	  setCookie(CACHE_KEY, 'true', 30);
	  if(timeoutMessage) {
		popupBody.append(timeoutMessage);
		timeoutMessage.style.display = "flex";
	  }
	}
  }

  // Overlay logic (supports multiple overlay templates)
  const overlayTimeoutIds = [];
  function setupOverlayTemplates() {
	if (!popup) return;
	if (location.pathname.startsWith('/en')) return;

	// Collect both newsletter and content overlays
	const templates = document.querySelectorAll('.newsletter-overlay-template[data-newsletter-overlay-template], .newsletter-overlay-template[data-content-overlay-template]');
	if (!templates.length) return;

	// Clean previous overlays and timers
	overlayTimeoutIds.forEach(id => clearTimeout(id));
	overlayTimeoutIds.length = 0;
	popup.querySelectorAll('.newsletter-overlay').forEach(el => el.remove());

	templates.forEach((tmpl, idx) => {
	  const delayMs = parseInt(tmpl.getAttribute('data-delay-ms') || '0', 10);

	  const overlay = document.createElement('div');
	  overlay.className = 'newsletter-overlay hidden';
	  overlay.innerHTML = tmpl.innerHTML;

	  // Mount inside the modal wrap so we can align with its padding (exclude PDF padding)
	  const mountWrap = popupBody?.closest('.custom-modal-wrap') || popupBody?.parentElement || popup;
	  mountWrap.appendChild(overlay);

	  // Align overlay to exclude parent padding (avoid covering PDF padding/margins)
	  try {
		const cs = window.getComputedStyle(mountWrap);
		overlay.style.top = cs.paddingTop;
		overlay.style.right = cs.paddingRight;
		overlay.style.bottom = cs.paddingBottom;
		overlay.style.left = cs.paddingLeft;
	  } catch (e) {
		// ignore
	  }

	  // Prevent click bubbling
	  overlay.addEventListener('click', (e) => e.stopPropagation());

	  // Localize return_to (prefix /en if site is in English locale)
	  try {
		const isEnglish = location.pathname.startsWith('/en');
		const rt = (isEnglish ? '/en' : '') + '/pages/wie-vegan?guide-highlight=signup-success&open-modal=true';
		overlay.querySelectorAll('input[name="return_to"]').forEach((el) => el.value = rt);
	  } catch (e) {
		// ignore
	  }

	  // Close button only hides overlay
	  const closeBtn = overlay.querySelector('.newsletter-close, .overlay-close');
	  if (closeBtn) {
		closeBtn.addEventListener('click', (e) => {
		  e.preventDefault();
		  e.stopPropagation();
		  overlay.classList.add('closing');
		  overlay.addEventListener('animationend', () => overlay.remove(), { once: true });
		});
	  }

	  const showId = setTimeout(() => {
		overlay.classList.remove('hidden');
	  }, Math.max(0, delayMs));

	  overlayTimeoutIds.push(showId);
	});
  }

  openButtons.forEach((button, index) => {
	if(getCookie(ACCESS_KEY) && index === 1 && !popup.classList.contains("member-access")) {
	  button.insertAdjacentHTML('afterend', " 🔓");
	}

	button.addEventListener('click', async (e) => {
	  e.preventDefault();
	  e.stopPropagation();
	  
	  // Check if this is a video download button
	  if (button.hasAttribute('data-video-download')) {
		handleVideoDownloadPopup(button);
		return;
	  }

	  if (getCookie(CACHE_KEY) === 'true' && !popup.classList.contains("member-access")) {
		if(getCookie(ACCESS_KEY) && index === 1) {
		} else {
		  popup?.classList.remove("document");
		  document.body.classList.add('no-pinch');
		  popup?.classList.add("modal-open");
		  popup.style.display = "visible";
		  showMessage();
		  return;
		}
	  }

	  startLoadingSpinner(popupBody); // Only show spinner if load takes longer than 300ms

	  const dataPdf = button.getAttribute('data-pdf');
	  if (!dataPdf) {
		console.error('No data-pdf attribute found on button:', button);
		stopLoadingSpinner(popupBody);
		return;
	  }
	  const pdfUrl = xorDecrypt(dataPdf, "🌱");
	  console.log("decrypted: " + pdfUrl);

	  if (window.nvsinoTrack) {
		window.nvsinoTrack('guide_geoeffnet', {
		  guide: (button.getAttribute('data-anchor') || pdfUrl.split('/').pop() || '').slice(0, 80)
		});
	  }

	  // Set classes for PopUp
	  document.body.classList.add('no-pinch');
	  popup?.classList.add("modal-open");
	  popup?.classList.add("document");

	  // Schedule overlays (independent from visual timer)
	  setupOverlayTemplates();

	  // check if all documents are unlocked with exception of protein guide if unlocked on social media(index:1)
	  // Only start timer if timeout is not disabled
	  if(!popup.classList.contains("member-access") && !(getCookie(ACCESS_KEY) && index === 1) && !isTimeoutDisabled) {
		console.log("Timer started - timeout not disabled");
		if (!timerStarted) {
		  setTimeout(() => {
			startTimer();
		  }, DELAY_BEFORE_START_MS);
		} else {
		  progressContainer.style.display = 'flex';
		  countdownInterval?.resume();
		}
	  } else if (isTimeoutDisabled) {
		console.log("Timer disabled via membership settings");
	  }

	  // update url
	  const anchor = button.getAttribute('data-anchor');
	  const newUrl = '?open-modal=true#' + anchor;
	  history.pushState(null, "", window.location.pathname + newUrl);

	  try {
		await renderAllPages(pdfUrl);
		zoomControls.style.display = 'flex';
		stopLoadingSpinner(popupBody); // Cancel spinner and hide it
	  } catch (error) {
		console.error("❌ Failed to load PDF:", error);

		const errorMsg = document.createElement("div");
		errorMsg.className = "pdf-error";
		errorMsg.textContent = "⚠️ Something went wrong, trying to display raw file instead.";
		errorMsg.style.cssText = `
		  color: red;
		  background: #ffe6e6;
		  padding: 1rem;
		  margin: 1rem 0;
		  border: 1px solid red;
		  border-radius: 4px;
		  font-family: sans-serif;
		`;

		const fallbackIframe = document.createElement("iframe");
		fallbackIframe.src = pdfUrl.replace("/view", "/preview");
		fallbackIframe.sandbox = "allow-same-origin allow-scripts allow-downloads allow-forms allow-popups";
		fallbackIframe.style.cssText = `
		  width: 100%;
		  height: 100%;
		  position: absolute;
		  left: 0;
		  top: 0;
		  border: none;
		`;

		fallbackIframe.onload = function() {
		  setTimeout(() => {
			if (errorMsg && errorMsg.parentNode) {
			  errorMsg.parentNode.removeChild(errorMsg);
			}
		  }, 5000);
		};

		popupBody.innerHTML = "";
		popupBody.appendChild(errorMsg);
		popupBody.appendChild(fallbackIframe);
	  }

	});

	return false;
  });

  closeButton.addEventListener('click', () => {
	document.body.classList.remove('no-pinch');
	popup.classList.add("modal-closed");
	countdownInterval?.pause();
	progressContainer.style.display = 'none';
	zoomControls.style.display = 'none';
	progressBar.style.strokeDashoffset = 0;
	progressText.textContent = TIME_LIMIT_SECONDS * 60;

	// Clean up overlays and timers
	overlayTimeoutIds.forEach(id => clearTimeout(id));
	overlayTimeoutIds.length = 0;
	popup?.querySelectorAll('.newsletter-overlay')?.forEach(el => el.remove());

	// After fadeOut animation
	setTimeout(function() {
	  clearPdfContent();
	  popupBody.innerHTML = originalPopupBodyHTML;
	  popup.classList.remove("document");
	}, 500);
	//reset url
	history.replaceState(null, "", window.location.pathname);
  });

  // Limit Warp Space Mode for Tobi
  const MIN_ZOOM_SCALE = 0.1;
  const MAX_ZOOM_SCALE = 2;

  // 6) Zoom buttons
  function zoomBy(factor) {
	let oldScale = pdfViewer.currentScale;

	// Default to 1 if currentScale isn't valid
	if (typeof oldScale !== "number" || isNaN(oldScale)) oldScale = 1;

	let newScale = oldScale * factor;

	// Clamp between valid bounds
	const minScale = MIN_ZOOM_SCALE;
	const maxScale = MAX_ZOOM_SCALE;
	newScale = Math.max(minScale, Math.min(newScale, maxScale));

	// Skip if no actual change
	if (Math.abs(newScale - oldScale) < 0.01) return;

	// 2) Figure out the center of the visible area (in container coords)
	const rect = container.getBoundingClientRect();
	const midX = rect.width  / 2;
	const midY = rect.height / 2;

	// 3) Compute the PDF-space point that sits at that center now
	const contentX = (container.scrollLeft + midX) / oldScale;
	const contentY = (container.scrollTop  + midY) / oldScale;

	pdfViewer._setScale(newScale, false);

	// 5) Scroll so that same PDF-space point stays under the center
	container.scrollLeft = (contentX * newScale) - midX;
	container.scrollTop  = (contentY * newScale) - midY;
  }

  zoomInBtn.addEventListener('click',  () => zoomBy(1.25));
  zoomOutBtn.addEventListener('click', () => zoomBy(1 / 1.25));

  // 7) Pinch-to-zoom for mobile
  let initPinchDist    = null;
  let baseScale        = 1;
  let pinchMidX, pinchMidY;
  let contentMidX, contentMidY;

  function getDistance(touches) {
	const [a, b] = touches;
	const dx = a.clientX - b.clientX;
	const dy = a.clientY - b.clientY;
	return Math.hypot(dx, dy);
  }

  // Disable legacy gestures for iOS
  ['gesturestart','gesturechange','gestureend'].forEach(type => {
	document.addEventListener(type, e => {
	  e.preventDefault();
	});
  });

  // Touch start: capture distance, scale, midpoint & content‐coords
  document.addEventListener('touchstart', e => {
	if (e.touches.length === 2) {
	  e.preventDefault(); // disable browser zoom
	  initPinchDist = getDistance(e.touches);
	  baseScale     = pdfViewer.currentScale;

	  // midpoint in container‐local pixels
	  const rect = container.getBoundingClientRect();
	  pinchMidX = ((e.touches[0].clientX + e.touches[1].clientX) / 2) - rect.left;
	  pinchMidY = ((e.touches[0].clientY + e.touches[1].clientY) / 2) - rect.top;

	  // content coord under midpoint (unscaled PDF space)
	  contentMidX = (container.scrollLeft + pinchMidX) / baseScale;
	  contentMidY = (container.scrollTop  + pinchMidY) / baseScale;
	}
  });

  document.addEventListener('touchmove', e => {
	if (e.touches.length === 2 && initPinchDist) {
	  e.preventDefault(); // disable browser zoom

	  // compute new scale
	  const newDist = getDistance(e.touches);
	  let zoomSpeed = 1.25;
	  let scaleFactor = Math.pow((newDist / initPinchDist), zoomSpeed);
	  let newScale = baseScale * scaleFactor;

	  // Clamp scale limits
	  const minScale = MIN_ZOOM_SCALE;
	  const maxScale = MAX_ZOOM_SCALE;
	  newScale = Math.max(minScale, Math.min(newScale, maxScale));

	  // Skip if scale hasn't changed meaningfully
	  if (Math.abs(newScale - pdfViewer.currentScale) < 0.01) return;

	  // apply scale
	  pdfViewer._setScale(newScale, false);

	  // recompute scroll to keep contentMid under pinchMid
	  container.scrollLeft = (contentMidX * newScale) - pinchMidX;
	  container.scrollTop  = (contentMidY * newScale) - pinchMidY;
	}
  }, { passive: false });

  document.addEventListener('touchend', e => {
	if (e.touches.length < 2) {
	  initPinchDist = null;
	}
  });

  function openPopUpOnURI() {
	// Open modal if ?open-modal=true is in URL
	const params = new URLSearchParams(window.location.search);
	const openModal = params.get("open-modal");
	const guideHighlight = params.get("guide-highlight");
	const windowMode = params.get("window-mode");
	if (openModal === "true" && window.location.hash.length > 0 || openModal === "true" && guideHighlight.length) {
	  popup.classList.add("transition-in");

	  setTimeout(function() {
		popup.classList.remove("modal-closed transition-in");
	  }, 300);

	  // Hide close button if inline mode
	  if(windowMode === "inline") {
		closeButton.remove();
		popup.classList.add("opaque");
		document.body.classList.add("no-pinch");
		popup.classList.remove("document");
		document.removeEventListener("click", closePopup);
		closePopup = null;
		const ArrowHint = `
		  <svg class="floating-arrow" width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"
			style="position: absolute; top: 0; left: -2.5px; z-index: 1000"
			viewBox="0 0 24 24">
			<path d="M12 16L12 8" stroke="white" stroke-width="0.6" stroke-linecap="square"/>
			<path d="M8 12L12 8L16 12" stroke="white" stroke-width="0.6" stroke-linecap="square"/>
		  </svg>
		`;
		popup.insertAdjacentHTML('afterbegin', ArrowHint);
		// Grant access to protein guide only
		setCookie(ACCESS_KEY, 'true', 30);
		return;
	  }

	  const hash = window.location.hash;
	  if (hash) {
		const url = new URL(window.location.href);
		const currentHash = window.location.hash.substring(1); // Remove the '#'
		// Fix for language mismatch in social leads
		const proteinLink = document.querySelector(`a[data-anchor="The%20Vegan%20PROTEIN%20GUIDE"]`);
		if(currentHash === "The%20Vegan%20PROTEIN%20GUIDE" && proteinLink) {
		  proteinLink.click();
		  return;
		}
		// Map German starterkit hash to English anchor when on English site
		const resolvedHash = (location.pathname.startsWith('/en') && currentHash === 'Startpaket.pdf') ? 'Starterkit.pdf' : currentHash;
		const targetLink = document.querySelector(`a[data-anchor="${resolvedHash}"]`);

		if (targetLink) {
		  targetLink.click();
		} else {
		  console.log("No matching anchor found.");
		}
	  }
	}
  }

  // Handle video download popup
  function handleVideoDownloadPopup(button) {
	console.log('Video download button clicked - showing membership popup');
	if (window.nvsinoTrack) {
	  window.nvsinoTrack('download_gesperrt', {
		typ: 'video', datei: (button.getAttribute('data-filename') || '').slice(0, 80)
	  });
	}
	
	// Get video download data
	const videoUrl = button.getAttribute('data-video-url');
	const videoType = button.getAttribute('data-video-type');
	const filename = button.getAttribute('data-filename');
	
	console.log('Video download data:', { videoUrl, videoType, filename });
	
	// Show the membership popup with message
	document.body.classList.add('no-pinch');
	popup?.classList.add("modal-open");
	popup?.classList.remove("document");
	
	// Show the original popup message content
	showMessage();
	
	// Store video download data for potential future use after signup
	if (videoUrl) {
	  sessionStorage.setItem('pendingVideoDownload', JSON.stringify({
		url: videoUrl,
		type: videoType,
		filename: filename,
		timestamp: Date.now()
	  }));
	}
  }
  
  // Expose function globally if needed
  window.handleVideoDownloadPopup = handleVideoDownloadPopup;

  // Force file download even for cross-origin CDN URLs (browsers ignore the
  // download attribute cross-origin, which would open the file instead)
  async function downloadFile(url, filename) {
	if (window.nvsinoTrack) window.nvsinoTrack('guide_download', { datei: (filename || '').slice(0, 80) });
	try {
	  const response = await fetch(url);
	  if (!response.ok) throw new Error('HTTP ' + response.status);
	  const blob = await response.blob();
	  const a = document.createElement('a');
	  a.href = URL.createObjectURL(blob);
	  a.download = filename || '';
	  document.body.appendChild(a);
	  a.click();
	  a.remove();
	  URL.revokeObjectURL(a.href);
	} catch (e) {
	  console.error('Download fehlgeschlagen, öffne Datei direkt:', e);
	  window.open(url, '_blank');
	}
  }
  window.downloadFile = downloadFile;

  window.onhashchange = openPopUpOnURI;

  openPopUpOnURI();

});
